import graphqlClient from "../../../apollo";

class StockOperationProvider {

    populateStocks() {
        return graphqlClient.mutate({
            mutation: require('./gql/StockOperation/populateStocks.graphql'),
        })
    }

    addStockOperation(stock, items, reason) {
        return graphqlClient.mutate({
            mutation: require('./gql/StockOperation/addStockOperation.graphql'),
            variables: {input: {stock, items, reason} }
        })
    }

    removeStockOperation(stock, items, reason) {
        return graphqlClient.mutate({
            mutation: require('./gql/StockOperation/removeStockOperation.graphql'),
            variables: {input: {stock, items, reason} }
        })
    }

    regularizeStockOperation(stock, items, reason) {
        return graphqlClient.mutate({
            mutation: require('./gql/StockOperation/regularizeStockOperation.graphql'),
            variables: {input: {stock, items, reason} }
        })
    }

    moveStockOperation(stock, stockDest, items, reason) {
        return graphqlClient.mutate({
            mutation: require('./gql/StockOperation/moveStockOperation.graphql'),
            variables: {input: {stock, stockDest, items, reason} }
        })
    }
}

export default new StockOperationProvider()


